import moment from 'moment-timezone';

export function dateParser(string) {
    // time zone stuff. string comes in with eastern time zone formatting, need to get local time zone and try to offset it. 
    let date = moment.tz(string, "America/New_York").clone().tz(moment.tz.guess()).format('MM/DD/YY hh:mm A')
    // console.log(moment.tz.guess())
    return `${date.toLocaleString()}`
}

export function dynamicSort(property) {
    return function (a, b) {
        var result
        if (a[property] % 1 === 0) {
            result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        } else if (a[property] === null || b[property] === null) {
            result = (a[property] === null && b[property] !== null) ? 1 : (a[property] !== null && b[property] === null) ? -1 : 0 
        }
        else {
            result = (a[property].toLowerCase() < b[property].toLowerCase()) ? -1 : (a[property].toLowerCase() > b[property].toLowerCase()) ? 1 : 0;
        }
        return result;
    }
}

export function doesThisUserHaveThisAuthorization(user, permission) {
    let rtnVal = false

    // First check if the user is one of specific admins
    if (user["applicationUserRoles"] !== null) {
        let applicationUserRoles = user["applicationUserRoles"]
        applicationUserRoles.forEach(r => {
            let role = r["role"]
            if (role["name"] === "IEAdmin") {
                rtnVal = true
            }
        })
    }
    
    // If not, check for explicit permission
    if (rtnVal === false) {
        if (user["applicationUserClaims"] !== null) {
            let applicationUserClaims = user["applicationUserClaims"]
            applicationUserClaims.forEach(a => {
                if (a["claimValue"] === permission) {
                    rtnVal = true;
                }
            })
        }
    }
    
    return rtnVal
}

export function DoesThisUserHavePermissionToEditTheFrontPageText(user) {
    let rtnVal = false

    // First check if the user is one of specific admins
    if (user["applicationUserRoles"] !== null) {
        let applicationUserRoles = user["applicationUserRoles"]
        applicationUserRoles.forEach(r => {
            let role = r["role"]
            if (role["name"] === "IEAdmin") { rtnVal = true }
            if (role["name"] === "Builder") { rtnVal = true }
            if (role["name"] === "ClientAdmin") { rtnVal = true }
        })
    }

    return rtnVal
}

export function IsThisUserThePresentationsCreator(user, presentation) {
    return user["email"].toLowerCase() === presentation["createdBy"].toLowerCase()
}

export function SeparateFileNameAndExtension(fullFileName) {
    let rtnVal = { "name": "", "ext": "" }

    if (fullFileName.length > 0) {
        let parts = fullFileName.split(".")
        let partsWithoutLast = parts.splice(0, parts.length - 1)

        rtnVal["name"] = partsWithoutLast.join(".")
        rtnVal["ext"] = parts[parts.length - 1]
    }

    return rtnVal
}

export function FormatHomePageMessage(message) {
    if (message === null) {
        return null;
    } else if (message === undefined) {
        return null;
    }

    return message.replace(/[\n\r]/g, '<br />');
}

export function HandlePresentationFilter(presentationFilter) {
    let rtnVal = {
        "value": 0,
        "label": "myPresentations"
    }

    if (presentationFilter) {
        let split = presentationFilter.split('|')

        if (split.length >= 2) {
            let filterValue = split[1]

            if (filterValue === "allPresentations") {
                rtnVal["value"] = 1
                rtnVal["label"] = "allPresentations"
            } else if (filterValue === "templates") {
                rtnVal["value"] = 2
                rtnVal["label"] = "templates"
            }
        }
    }

    return rtnVal;
}

export function IsThisConnectionPowerBi(connectionName) {
    return (connectionName.toString().indexOf("\\PowerBI") > -1);
}